import textStyles from "../../../styles/UI/textComponents.module.css";

const Body2 = ({
  children,
  color,
  bold,
  whiteSpaceNoWrap,
}: {
  children: string | React.ReactNode;
  color?: string;
  bold?: boolean;
  whiteSpaceNoWrap?: boolean;
}) => {
  return (
    <p
      className={`${textStyles.body2} ${bold ? "bold" : ""} !w-full !max-w-none`}
      style={{
        color: color ? color : "var(--col-text-primary)",
        whiteSpace: whiteSpaceNoWrap ? "nowrap" : "normal",
      }}
    >
      {children}
    </p>
  );
};

export default Body2;
